<template>
  <el-dialog :close-on-click-modal="false" title="添加资源" @open="handleDialogOpen" :visible.sync="dialogVisible"
    width="160rem" :before-close="handleClose">
    <div class="top-box">
      <p style="color: #8590b3">教学单元：</p>
      <div>{{ teachUnit.name }}</div>
      <div class="type-label" :style="`color:rgb(255, 192, 56);background-color:rgba(255, 192, 56,0.1);`">视频</div>
      <el-radio-group v-model="radio" @change="changeMethod" style="margin-left: 4rem">
        <el-radio :label="2">按进度添加</el-radio>
        <el-radio :label="0">全局添加</el-radio>
      </el-radio-group>
    </div>
    <div class="radio-box">
      <div>资源类型：</div>
      <el-radio-group v-model="classifyCode" @input="changeCategory">
        <el-radio v-for="(item, index) in Category" :key="index" :label="item.value">{{ item.label }}</el-radio>
      </el-radio-group>
    </div>
    <div class="content-box">
      <div class="left-box">
        <div class="video-p">
          <video class="video-box" v-if="!isDestroy" ref="audio" id="audio" controls></video>
          <div>
            <div v-for="(item, index) in selectDataObj" :key="index">
              <el-tooltip class="item" effect="dark" :content="Number(index).toFixed(1)" placement="top-start">
                <img class="slider" src="../../../assets/image/course/slider.png" :id="index"
                  :style="`left:calc(${setNodePos(index)}% + 1.1rem);`" @click="changeId(index)" :key="index" alt="">
              </el-tooltip>
            </div>
          </div>
          <img class="stop" v-show="radio == 2" @click="addNodeRes" src="../../../assets/image/course/stop.png" alt="">
          <i class="active-time" v-show="currentId && radio == 2"></i>
        </div>
        <div class="select-box">
          <div v-for="(item, index) in filterSelctList" class="select-item" @click="mainUnbindData(item.id)"
            :key="index">
            <el-tooltip class="item" effect="dark" :content="item.resourceName" placement="top-start">
              <div slot="content">
                <div v-html="item.resourceName"></div>
              </div>
              <p class="overflow html-ev" style="width: 6.1rem;" v-html="item.resourceName"></p>
            </el-tooltip>
            <i class="el-icon-close" style="cursor: pointer;"></i>
          </div>
          <div v-if="filterSelctList.length == 0" class="tip-box">
            <i class="iconfont icon-gantanhao-yuankuang"></i>
            <p>点选下方文件，添加资源</p>
          </div>
        </div>
      </div>
      <div class="right-box">
        <div class="input-box" v-if="activeName != 'local'">
          <div @click="handleClick">搜索</div>
          <el-input v-model="keywords" @keydown.enter.native="handleClick" clearable @clear="handleClick"
            placeholder="请输入关键字">
            <img slot="prefix" class="search-img" src="../../../assets/image/magSys/search.png" @click="handleClick"
              alt="">
          </el-input>
        </div>
        <el-tabs v-model="activeName" @tab-click="changeTab">
          <el-tab-pane :label="`个人资源库（${resNum[2]}）`" name="myself">
            <div class="box-content">
              <div class="left-box-container">
                <div v-for="(item, index) in resourceType" style="position: relative;" :key="index"
                  @click="changeType(index)">
                  <el-tooltip class="item" v-if="staticsNumber(index) > 0" effect="dark"
                    :content="'已绑定资源数量：' + staticsNumber(index)" placement="top-start">
                    <p class="num1">{{ staticsNumber(index) }}</p>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="'资源数量：' + getResNum(index)" placement="top-start">
                    <p class="num2" style="cursor: pointer;" :class="{ 'active': index == currentType }">{{
                      `（${getResNum(index) < 100 ? getResNum(index) : '99+'}）` }}</p>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="index" placement="top-start">
                    <img class="type-img-style" :src="index == currentType ? imgList[item] : imgList['no-' + item]"
                      alt="">
                  </el-tooltip>
                </div>
              </div>
              <div class="right-box-container">
                <div class="table-box">
                  <div v-for="(item, index) in tableData" class="table-item" @click="selectRes(item)" :key="index">
                    <div class="cover-box">
                      <img :class="{ 'active-img': isSelect(item.id) }" class="res-img"
                        :src="item.coverPath ? $severUrl(item.coverPath) : $filterResDefault(item.type)" alt="">
                    </div>
                    <el-tooltip effect="dark" v-if="item.type == '题库'" placement="top-start">
                      <div slot="content" v-html="item.resourceName"></div>
                      <div v-html="item.resourceName" style="margin-top: 0.5rem;" class="overflow html-ev"
                        :class="{ 'active-select': isSelect(item.id) }"></div>
                    </el-tooltip>
                    <el-tooltip v-else effect="dark" :content="item.resourceName" placement="top-start">
                      <div style="margin-top: 0.5rem;" class="overflow" :class="{ 'active-select': isSelect(item.id) }">
                        {{
                          item.resourceName }}</div>
                    </el-tooltip>
                  </div>
                </div>
                <div class="page-box" v-if="tableData.length > 0">
                  <el-pagination :current-page="pages.current" :page-size="pages.size" background
                    layout="prev, pager, next" @current-change="changeCurrent" :total="pages.total">
                  </el-pagination>
                </div>
                <no-data style="margin-top: 7rem;" v-else></no-data>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="`院校资源库（${resNum['1']}）`" name="college">
            <div class="box-content">
              <div class="left-box-container">
                <div v-for="(item, index) in resourceType" style="position: relative;" @click="changeType(index)"
                  :key="index">
                  <el-tooltip class="item" v-if="staticsNumber(index) > 0" effect="dark"
                    :content="'已绑定资源数量：' + staticsNumber(index)" placement="top-start">
                    <p class="num1">{{ staticsNumber(index) }}</p>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="'资源数量：' + getResNum(index)" placement="top-start">
                    <p class="num2" style="cursor: pointer;" :class="{ 'active': index == currentType }">{{
                      `（${getResNum(index) < 100 ? getResNum(index) : '99+'}）` }}</p>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="index" placement="top-start">
                    <img class="type-img-style" :src="index == currentType ? imgList[item] : imgList['no-' + item]"
                      alt="">
                  </el-tooltip>
                </div>
              </div>
              <div class="right-box-container">
                <div class="table-box">
                  <div v-for="(item, index) in tableData" class="table-item" @click="selectRes(item)" :key="index">
                    <div class="cover-box">
                      <img :class="{ 'active-img': isSelect(item.id) }" class="res-img"
                        :src="item.coverPath ? $severUrl(item.coverPath) : $filterResDefault(item.type)" alt="">
                    </div>
                    <el-tooltip effect="dark" v-if="item.type == '题库'" placement="top-start">
                      <div slot="content" v-html="item.resourceName"></div>
                      <div v-html="item.resourceName" style="margin-top: 0.5rem;" class="overflow html-ev"
                        :class="{ 'active-select': isSelect(item.id) }"></div>
                    </el-tooltip>
                    <el-tooltip effect="dark" v-else :content="item.resourceName" placement="top-start">
                      <div style="margin-top: 0.5rem;" class="overflow" :class="{ 'active-select': isSelect(item.id) }">
                        {{
                          item.resourceName }}</div>
                    </el-tooltip>
                  </div>
                </div>
                <div class="page-box" v-if="tableData.length > 0">
                  <el-pagination :current-page="pages.current" :page-size="pages.size" background
                    layout="prev, pager, next" @current-change="changeCurrent" :total="pages.total">
                  </el-pagination>
                </div>
                <no-data style="margin-top: 7rem;" v-else></no-data>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="`平台资源库（${resNum['0']}）`" name="cloud">
            <div class="box-content">
              <div class="left-box-container">
                <div v-for="(item, index) in resourceType" style="position: relative;" @click="changeType(index)"
                  :key="index">
                  <el-tooltip class="item" v-if="staticsNumber(index) > 0" effect="dark"
                    :content="'已绑定资源数量：' + staticsNumber(index)" placement="top-start">
                    <p class="num1">{{ staticsNumber(index) }}</p>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" :content="'资源数量：' + getResNum(index)" placement="top-start">
                    <p class="num2" style="cursor: pointer;" :class="{ 'active': index == currentType }">{{
                      `（${getResNum(index) < 100 ? getResNum(index) : '99+'}）` }}</p>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="index" placement="top-start">
                    <img class="type-img-style" :src="index == currentType ? imgList[item] : imgList['no-' + item]"
                      alt="">
                  </el-tooltip>
                </div>
              </div>
              <div class="right-box-container">
                <div class="table-box">
                  <div v-for="(item, index) in tableData" class="table-item" @click="selectRes(item)" :key="index">
                    <div class="cover-box">
                      <img :class="{ 'active-img': isSelect(item.id) }" class="res-img"
                        :src="item.coverPath ? $severUrl(item.coverPath) : $filterResDefault(item.type)" alt="">
                    </div>
                    <el-tooltip effect="dark" v-if="item.type == '题库'" placement="top-start">
                      <div slot="content" v-html="item.resourceName"></div>
                      <div v-html="item.resourceName" style="margin-top: 0.5rem;" class="overflow html-ev"
                        :class="{ 'active-select': isSelect(item.id) }"></div>
                    </el-tooltip>
                    <el-tooltip effect="dark" v-else :content="item.resourceName" placement="top-start">
                      <div style="margin-top: 0.5rem;" class="overflow" :class="{ 'active-select': isSelect(item.id) }">
                        {{
                          item.resourceName }}</div>
                    </el-tooltip>
                  </div>
                </div>
                <div class="page-box" v-if="tableData.length > 0">
                  <el-pagination :current-page="pages.current" :page-size="pages.size" background
                    layout="prev, pager, next" @current-change="changeCurrent" :total="pages.total">
                  </el-pagination>
                </div>
                <no-data style="margin-top: 7rem;" v-else></no-data>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="本地添加" name="local" v-if="currentType != '题库'">
            <div class="box-content">
              <div class="left-box-container">
                <div v-for="(item, index) in resourceType" style="position: relative;" :key="index"
                  @click="changeType(index)">
                  <el-tooltip class="item" effect="dark" :content="'已绑定资源数量：' + staticsNumber(index)"
                    placement="top-start">
                    <p class="num1" v-if="staticsNumber(index) > 0">{{ staticsNumber(index) }}</p>
                  </el-tooltip>
                  <el-tooltip effect="dark" :content="index" placement="top-start">
                    <img class="type-img-style" :src="index == currentType ? imgList[item] : imgList['no-' + item]"
                      alt="">
                  </el-tooltip>
                </div>
              </div>
              <div v-if="radio == 1 && !currentId" class="mi-tip-box">按进度添加请先选择进度!</div>
              <div class="right-box-container" v-else>
                <div style="display: flex;align-items: center;margin-bottom: 2rem;">
                  <div>资源名称</div>
                  <el-input style="width: 100%;margin-left: 2rem;" v-model="form.resourceName"
                    placeholder="请输入资源名称"></el-input>
                </div>
                <div style="display: flex;align-items: center;margin-bottom: 2rem;">
                  <div>资源简介</div>
                  <el-input type="textarea" style="width: 100%;margin-left: 2rem;" v-model="form.info"
                    placeholder="请输入资源名称"></el-input>
                </div>
                <div class="t-cover-box" v-if="currentType != '图片'">
                  <div>资源封面</div>
                  <el-upload style="width: 5rem !important; height: 5rem !important" action="#" accept=".jpg,.jpeg,.png"
                    list-type="picture-card" :auto-upload="false" :show-file-list="false" class="upload-box-img"
                    :on-change="uploadCover">
                    <img v-if="form.coverPath" :src="$severUrl(form.coverPath)"
                      style="width: 4.8rem; height: 4.8rem;object-fit: cover;" />
                    <i v-else class="el-icon-plus"></i>
                  </el-upload>
                </div>
                <div v-if="currentType == '仿真软件'" style="margin-bottom: 2rem;">
                  <div class="software-item">
                    <div>资源类型</div>
                    <el-radio-group v-model="form.resType" @input="changeResType">
                      <el-radio label="单机">单机</el-radio>
                      <el-radio label="网页">网页</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="software-item" v-if="form.resType == '单机'">
                    <upload-chunk style="width: 100%;" :multiple="false" ref="software_chunk" @upload="loaclUpload"
                      @del_file="loaclUpload" accept=".exe,.zip"></upload-chunk>
                  </div>
                  <div class="software-item" v-if="form.resType == '单机'">
                    <div>注册表地址</div>
                    <el-input style="width: 100%;" v-model="form.regedit" placeholder="请输入注册表地址"></el-input>
                  </div>
                  <div class="software-item" v-if="form.resType == '网页'">
                    <div>资源链接</div>
                    <el-input style="width: 100%;" v-model="form.url" placeholder="请输入资源链接"></el-input>
                  </div>
                  <div class="software-item">
                    <div>实训目标</div>
                    <el-input style="width: 100%;" type="textarea" v-model="form.drillTarget"
                      placeholder="请输入实训目标"></el-input>
                  </div>
                  <div class="software-item">
                    <div>实训原理</div>
                    <el-input style="width: 100%;" type="textarea" v-model="form.drillTheory"
                      placeholder="请输入实训原理"></el-input>
                  </div>
                  <div class="software-item">
                    <div>实训步骤</div>
                    <el-input style="width: 100%;" type="textarea" v-model="form.drillStep"
                      placeholder="请输入实训步骤"></el-input>
                  </div>
                  <div class="software-item">
                    <div>实训方法与过程</div>
                    <el-input style="width: 100%;" type="textarea" v-model="form.drillMethodCourse"
                      placeholder="请输入实训方法与过程"></el-input>
                  </div>
                  <div class="software-item">
                    <div>实训结论</div>
                    <el-input style="width: 100%;" type="textarea" v-model="form.drillConclusion"
                      placeholder="请输入实训结论"></el-input>
                  </div>
                  <div class="software-item">
                    <div>硬件要求</div>
                    <el-input style="width: 100%;" type="textarea" v-model="form.hardwareAsk"
                      placeholder="请输入硬件要求"></el-input>
                  </div>
                  <div class="software-item">
                    <div>操作系统</div>
                    <el-input style="width: 100%;" type="textarea" v-model="form.os" placeholder="请输入操作系统"></el-input>
                  </div>
                  <div class="software-item">
                    <div>网络要求</div>
                    <el-input style="width: 100%;" type="textarea" v-model="form.networkAsk"
                      placeholder="请输入网络要求"></el-input>
                  </div>
                </div>
                <div v-else class="upload-box">
                  <upload-chunk ref="chunk1" :multiple="false" :accept="uploadAccept" @upload="loaclUpload"
                    @del_file="loaclUpload"></upload-chunk>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="`已绑资源（${hasBindRes.tableData.length}）`" name="hasBind">
            <Table :pagination="false" :serialNumber="false" :operationWidth="350"
              :currentPage="hasBindRes.pages.current" :pageSize="hasBindRes.pages.size" navHeight=40 ref="table"
              :tableData="hasBindRes.tableData" :tableKey="hasBindRes.tableKey">
              <template slot="classifyCode" slot-scope="data">
                <p style="color: #000000;">{{ filterClassifyCode(data.data.row.classifyCode) }}</p>
              </template>
              <template slot="bindResSource" slot-scope="data">
                <p style="color: #000000;">{{ filterOrigin(data.data.row.bindResSource) }}</p>
              </template>
              <template slot="nodeId" slot-scope="data">
                <p style="color: #000000;">{{ data.data.row.nodeId ? (Number(data.data.row.nodeId)).toFixed(1) : '' }}
                </p>
              </template>
              <template slot="operation" slot-scope="data">
                <div style="display: flex;">
                  <div class="operation-text" @click="mainUnbindData(data.data.row.id)">解除绑定</div>
                </div>
              </template>
            </Table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" v-if="isConfirm" @click="save">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import UploadChunk from '../../common/UploadChunk.vue';
import { Category } from '@/utils/utils';
import { SoftwarePageList, AddSoftware, CheckSoftware } from '@/api/software';
import { ResourcePreview, GetBindData, MainBindData, PageResourceList, MainUnbindData, AddResource, QueryResDataNode, GetDataTypeResDataCount } from '@/api/resourceMag';
import { PageSubject } from '@/api/subject';
import { resImg,openVirtual } from '@/utils/utils';
import Hls from 'hls.js';
import { uploadFile } from '@/assets/js/oss';
export default {
  components: { UploadChunk },
  props: {
    teachUnit: {
      require: true,
      default: () => { }
    }
  },
  data() {
    return {
      imgList: resImg(),
      /**资源数量 */
      resNum: {
        '0': 0,
        '1': 0,
        '2': 0
      },
      /**已绑资源模块 */
      hasBindRes: {
        pages: {
          current: 1,
          size: 10,
          total: 0
        },
        tableData: [],
        tableKey: [
          { name: '资源名称', value: 'resourceName' },
          { name: '资源类型', value: 'type' },
          { name: '所属分类', value: 'classifyCode', slot: 'classifyCode' },
          { name: '进度时间点（s）', value: 'nodeId', slot: 'nodeId' },
          { name: '资源来源', value: 'bindResSource', slot: 'bindResSource' },
          { name: '操作', value: 'operation', slot: 'operation' },
        ],
      },
      resNumStatistics: [],
      radio: 2,
      /**搜索关键字 */
      keywords: "",
      pages: {
        current: 1,
        size: 8,
        total: 0
      },
      isDestroy: false,
      currentId: '',
      audio: null,
      dialogVisible: false,
      /**当前视频播放时间点 */
      timeupdate: '',
      videoUrl: '',
      classifyCode: 'CIS',
      Category,
      /**tab切换 */
      activeName: "myself",
      /**资源类型 */
      resourceType: {
        '仿真软件': 'fz',
        '模型': 'mx',
        '动画': 'dh',
        "ppt": 'ppt',
        '图片': 'tp',
        '文档': 'wd',
        '题库': 'tk',
      },
      currentType: "仿真软件",
      tableData: [],
      tableKey: [
        { name: '资源名称', value: 'resourceName', },
        { name: '资源类型', value: 'type', },
        { name: '添加方式', value: 'addType', slot: 'addType' },
        { name: '操作', value: 'operation', slot: 'operation' },
      ],
      selectDataObj: {},
      /**用于对比id */
      selectObj: {},
      /**已选资源列表 */
      selectList: [],
      form: {
        "classifyCode": "",
        "coverPath": "",
        "fileId": "",
        "fileName": '',
        "info": "",
        "url": '',
        "resUrl": "",
        "resourceName": '',
        "regedit": '',
        "resType": '单机',
        "drillTarget": '',
        "drillTheory": '',
        "drillStep": '',
        "drillMethodCourse": '',
        "drillConclusion": '',
        "hardwareAsk": '',
        "os": '',
        "networkAsk": ''
      }
    };
  },
  computed: {
    uploadAccept() {
      var obj = {
        '仿真软件': '.exe',
        '模型': '.fbx,.obj',
        '动画': '.fbx,.obj',
        '视频': '.mp4,.avi,.ts,.flv,.avi,.wmv',
        '图片': '.png,.jpg,.jpeg',
        '文档': ".doc,.docx,.pdf,.xls,.xlsx",
        'ppt': '.ppt,.pptx'
      }
      return obj[this.currentType];
    },
    isConfirm() {
      if (this.activeName == 'local') {
        return true;
      } else {
        return false;
      }
    },
    /**过滤已绑定资源类型 */
    filterSelctList() {
      return this.selectList.filter(item => item.type == this.currentType && item.classifyCode == this.classifyCode);
      // var obj = {
      //   0: 'cloud',
      //   1: 'college',
      //   2: 'myself'
      // }
      // return this.selectList.filter(item => item.type == this.currentType && item.classifyCode == this.classifyCode && obj[item.bindResSource] == this.activeName);
    }
  },
  methods: {
    /**过滤资源来源 */
    filterOrigin(type) {
      var obj = {
        0: '平台资源库',
        1: '院校资源库',
        2: '个人资源库'
      };
      return obj[type];
    },
    /**切换resType */
    changeResType() {
      this.$nextTick(() => {
        if (this.form.resType == '单机') {
          let dialog = this.$refs.software_chunk;
          if (dialog && this.form.fileId) {
            let data = {
              fileName: this.form.fileName,
              id: this.form.fileId,
              status: 'success'
            };
            dialog.fileArr = [data];
          }
        }
      })
    },
    /**过滤所属分类 */
    filterClassifyCode(classifyCode) {
      let el = Category.find(item => item.value == classifyCode);
      if (el) {
        return el.label;
      }
    },
    /**统计该类型已绑定资源数量 */
    staticsNumber(type) {
      var obj = {
        0: 'cloud',
        1: 'college',
        2: 'myself'
      }
      return this.selectList.filter(item => item.type == type && item.classifyCode == this.classifyCode && obj[item.bindResSource] == this.activeName).length;
    },
    /**分页查询题库 */
    pageSubject(dataType) {
      var params = {
        "classifyCode": this.classifyCode,
        "current": this.pages.current,
        "dataType": dataType,
        "questionStem": this.keywords,
        "size": this.pages.size,
      }
      PageSubject(params).then(res => {
        if (res.code == 200) {
          this.pages.total = res.data.total;
          this.tableData = res.data.records.map(item => {
            return {
              id: item.id,
              type: '题库',
              resourceName: item.questionStem
            }
          });;
        }
      })
    },
    openInit() {
      this.radio=2;
      this.activeName = 'myself';
      this.currentType = '仿真软件';
      this.keywords = '';
      this.isDestroy = false;
      this.classifyCode = this.$store.state.course.classifyCode;
      this.queryBindData();
    },
    getResNum(type) {
      var obj = {
        cloud: 0,
        college: 1,
        myself: 2
      }
      var el = this.resNumStatistics.find(item => {
        return item.dataType == obj[this.activeName] && item.type == type;
      })
      if (el) {
        return el.count;
      } else {
        return 0;
      }
    },
    /**切换资源类型 */
    changeCategory() {
      this.pages.current = 1;
      this.handleClick();
      this.getDataTypeResDataCount();
    },
    /**获取数据类型资源数量 */
    getDataTypeResDataCount() {
      var resTypeList = [];
      for (var key in this.resourceType) {
        resTypeList.push(key);
      }
      var params = {
        "classifyCode": this.classifyCode,
        "resTypeList": resTypeList
      };
      GetDataTypeResDataCount(params).then(res => {
        if (res.code == 200) {
          var resNum = {
            '0': 0,
            '1': 0,
            '2': 0
          }
          this.resNumStatistics = res.data;
          for (var key in resNum) {
            var arr = res.data.filter(item => item.dataType == key);
            arr.forEach(item => {
              resNum[key] = resNum[key] + item.count;
            })
          }
          this.resNum = resNum;
        }
      })
    },
    /**查询主体资源绑定节点 */
    queryResDataNode() {
      QueryResDataNode({ id: this.teachUnit.resourceId }).then(res => {
        if (res.code == 200) {
          var obj = {};
          res.data.forEach(item => {
            if (item) {
              obj[item] = '';
            }
          })
          this.selectDataObj = obj;
        }
      })
    },
    /**分页查询仿真软件 */
    softwarePageList(dataType) {
      var params = {
        "classifyCode": this.classifyCode,
        "current": this.pages.current,
        "dataType": dataType,
        "resType": '网页',
        "resourceName": this.form.resourceName,
        "size": this.pages.size,
        "third": false
      };
      SoftwarePageList(params).then(res => {
        if (res.code == 200) {
          this.pages.total = res.data.total;
          this.tableData = res.data.records.map(item => {
            return {
              coverPath: item.softwareCover,
              id: item.id,
              type: '仿真软件',
              url: item.url,
              resourceName: item.softwareName
            }
          });
        }
      })
    },
    /**本地新增资源 */
    addResource() {
      var params = {
        "classifyCode": this.classifyCode,
        "coverFileId": this.form.coverFileId,
        "coverPath": this.form.coverPath,
        "fileIds": [this.form.fileId],
        "fileName": this.form.fileName,
        "info": this.form.info,
        "resUrl": "",
        "resourceCode": "",
        "resourceName": this.form.resourceName,
        "type": this.currentType
      };
      AddResource(params).then(res => {
        if (res.code == 200) {
          this.bindToResourceId(res.data, () => {
            this.clearUpload();
          });
          this.getDataTypeResDataCount();
        }
      })
    },
    /**新增仿真软件 */
    addSoftware() {
      var params = {
        "classify": this.classifyCode,
        "explainInfo": this.form.info,
        "orderIndex": '',
        "softwareCode": "",
        "softwareCover": this.form.coverPath,
        "softwareName": this.form.resourceName,
        "resType": this.form.resType,
        "drillTarget": this.form.drillTarget,
        "drillTheory": this.form.drillTheory,
        "drillStep": this.form.drillStep,
        "drillMethodCourse": this.form.drillMethodCourse,
        "drillConclusion": this.form.drillConclusion,
        "hardwareAsk": this.form.hardwareAsk,
        "os": this.form.os,
        "networkAsk": this.form.networkAsk
      }
      if (this.form.resType == '单机') {
        params.fileId = this.form.fileId;
        params.url = this.form.fileName;
      } else {
        params.url = this.form.url;
      }
      AddSoftware(params).then(res => {
        if (res.code == 200) {
          this.bindToResourceId(res.data, () => {
            this.clearUpload();
          });
          this.getDataTypeResDataCount();
        }
      })
    },
    changeCurrent(e) {
      this.handleClick(e);
    },
    /**上传封面图 */
    uploadCover(e) {
      uploadFile(e.raw).then(res => {
        this.form.coverPath = res.previewUrl;
      })
    },
    /**判断是否为选中资源 */
    isSelect(id) {
      return this.selectObj[id];
    },
    /**教学单元主体资源绑定相关资源 */
    bindToResourceId(bindResId, callback) {
      var obj = {
        myself: 2,
        college: 1,
        cloud: 0,
        local: 2
      }
      var params = {
        "bindResId": bindResId,
        "bindResSource": obj[this.activeName],
        "bindResType": this.currentType,
        "bindType": this.radio,
        "nodeId": this.currentId,
        "resId": this.teachUnit.resourceId,
        "teachingUnitId": this.teachUnit.id
      }
      MainBindData(params).then(res => {
        if (res.code == 200) {
          this.getBindData();
          this.queryBindData();
          typeof callback == 'function' && callback();
        }
      })
    },
    /**查询主体资源已绑定资源 */
    getBindData() {
      if (this.radio && !this.currentId) return;
      var params = {
        "bindType": this.radio,
        "nodeId": this.currentId,
        "resId": this.teachUnit.resourceId
      };
      if (this.radio == 0) {
        params.teachingUnitId = this.teachUnit.id;
      }
      GetBindData(params).then(res => {
        if (res.code == 200) {
          this.selectList = res.data;
          var obj = {};
          this.selectList.forEach(item => {
            obj[item.originalResId] = true;
          })
          this.selectObj = obj;
        }
      })
    },
    /**查询已绑定资源列表 */
    queryBindData() {
      var params = {
        "bindType": this.radio,
        "resName": this.activeName == 'hasBind' ? this.keywords : '',
        "nodeId": '',
        "resId": this.teachUnit.resourceId
      };
      if (this.radio == 0) {
        params.teachingUnitId = this.teachUnit.id;
      }
      GetBindData(params).then(res => {
        if (res.code == 200) {
          this.hasBindRes.tableData = res.data;
        }
      })
    },
    /**解绑资源 */
    mainUnbindData(id) {
      MainUnbindData({ id }).then(res => {
        if (res.code == 200) {
          this.getBindData();
          this.queryBindData();
        }
      })
    },
    /**分页查询本地资源库 */
    localResource() {
      var params = {
        "classifyCode": this.classifyCode,
        "current": this.pages.current,
        "resourceCode": "",
        "resourceName": this.keywords,
        "size": this.pages.size,
        "types": [this.currentType]
      }
      LocalResource(params).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.pages.total = res.data.total;
        }
      })
    },
    /**分页查询基础资源 */
    pageResourceList(dataType) {
      var params = {
        "classifyCode": this.classifyCode,
        "current": this.pages.current,
        "dataType": dataType,
        "resourceName": this.keywords,
        "size": this.pages.size,
        "type": this.currentType
      };
      PageResourceList(params).then(res => {
        if (res.code == 200) {
          this.pages.total = res.data.total;
          this.tableData = res.data.records;
        }
      })
    },
    /**切换添加方式 */
    changeMethod() {
      if (this.radio == 0) {
        this.currentId = '';
        this.getBindData();
        this.queryBindData();
      } else {
        this.selectList = [];
        this.selectObj = {};
        this.queryBindData();
      }
    },
    /**切换id */
    changeId(id) {
      if (!this.radio) return;
      this.currentId = id;
      this.getBindData();
      var icon = document.querySelector('.active-time');
      if (icon) {
        const percent = (Number(id) / this.audio.duration) * 100;
        icon.style.left = `calc(${percent}% + 1.68rem)`;
      }
    },
    /**本地上传清空表单 */
    clearUpload() {
      this.form.coverFileId = '';
      this.form.coverPath = '';
      this.form.fileId = '';
      this.form.fileName = '';
      this.form.info = '';
      this.form.url = '';
      this.form.resourceName = '';
      this.form.regedit = '';
      this.form.resType = '单机';
      this.form.drillTarget = '';
      this.form.drillTheory = '';
      this.form.drillStep = '';
      this.form.drillMethodCourse = '';
      this.form.drillConclusion = '';
      this.form.hardwareAsk = '';
      this.form.os = '';
      this.form.networkAsk = '';
      var upload = this.$refs.chunk1;
      let chunk = this.$refs.software_chunk;
      if (upload) {
        upload.fileArr = [];
      };
      if (chunk) {
        chunk.fileArr = [];
      }
    },
    handleDialogOpen() {
      this.$nextTick(() => {
        this.audio = document.getElementById('audio');
        this.monitorVideo();
        this.handleClick();
      })
    },
    setNodePos(id) {
      const percent = (Number(id) / this.audio.duration) * 100;
      return percent;
    },
    /**为视频节点添加资源 */
    addNodeRes() {
      this.currentId = this.timeupdate;
      this.getBindData();
      this.queryBindData();
      this.$set(this.selectDataObj, this.currentId, '');
      this.$nextTick(() => {
        var icon2 = document.querySelector('.active-time');
        if (icon2) {
          const percent = (this.timeupdate / this.audio.duration) * 100;
          icon2.style.left = `calc(${percent}% + 1.68rem)`;
        }
      })
    },
    /**监听视频的播放 */
    monitorVideo() {
      var icon = document.querySelector('.stop');
      if (this.audio) {
        this.audio.addEventListener('loadedmetadata', () => {
          this.queryResDataNode();
        })
        this.audio.addEventListener('timeupdate', () => {
          this.timeupdate = this.audio.currentTime;
          const percent = (this.audio.currentTime / this.audio.duration) * 100;
          icon.style.left = `calc(${percent}% + 1.1rem)`;
        })
      }
    },
    /**切换tab */
    changeTab() {
      this.keywords = '';
      this.handleClick();
    },
    /**搜索 */
    handleClick(e) {
      if (this.activeName == 'hasBind') {
        this.queryBindData();
        return;
      }
      this.pages.current = (typeof e == 'number' ? e : 1);
      var obj = {
        myself: '2',
        college: '1',
        cloud: '0'
      }
      if (obj[this.activeName] === undefined) return;
      if (this.currentType == '仿真软件') {
        this.softwarePageList(obj[this.activeName]);
        return;
      } else if (this.currentType == '题库') {
        this.pageSubject(obj[this.activeName]);
        return;
      }
      this.pageResourceList(obj[this.activeName]);
    },
    /**选中资源 */
    selectRes(item) {
      if (this.radio && !this.currentId) {
        this.$msg({
          showClose: true,
          message: "请先选择进度",
          type: "warning",
        });
        return;
      };
      if (this.selectObj[item.id]) {
        let el = this.selectList.find(e => e.originalResId == item.id);
        el && this.mainUnbindData(el.id);
        return;
      };
      if (this.currentType == '仿真软件') {
        let fullPath = openVirtual(item.url);
        this.checkSoftware(fullPath, item.resourceName).then(() => {
          this.bindToResourceId(item.id);
        })
      } else {
        this.bindToResourceId(item.id);
      }
    },
    /**本地上传文件 */
    loaclUpload(files) {
      if (files.length == 0) {
        this.form.fileId = '';
      } else {
        this.form.fileId = files[0].id;
        this.form.fileName = files[0].fileName;
        if (!this.form.resourceName) {
          this.form.resourceName = this.form.fileName;
        }
      }
    },
    /**仿真资源校验 */
    checkSoftware(fullPath, softwareName) {
      let params = [
        {
          "fullPath": fullPath,
          "softwareName": softwareName
        }
      ];
      return new Promise(resolve => {
        CheckSoftware(params).then(res => {
          if (res.code == 200) {
            resolve();
          }
        })
      })
    },
    /**m3u8视频播放 */
    playVideo() {
      const audio = document.getElementById("audio");
      const hls = new Hls();
      if (Hls.isSupported()) {
        hls.loadSource(this.$severUrl(this.videoUrl));
        hls.attachMedia(audio);
        hls.on(Hls.Events.MANIFEST_PARSED, function () {
          audio.play();
        });
      } else if (audio.canPlayType("application/vnd.apple.mpegurl")) {
        audio.src = this.$severUrl(this.videoUrl);
        audio.addEventListener("canplay", function () {
          audio.play();
        });
      } else {
        console.error("HLS is not supported in this browser");
      }
    },
    /**主体资源预览查询 */
    mainPreview(callback) {
      var params = {
        id: this.teachUnit.resourceId,
      }
      ResourcePreview(params).then(res => {
        if (res.code == 200) {
          var el = res.data.find(item => {
            var url = item.filePreviewUrl;
            var arr = url.split('.');
            var suffix = arr[arr.length - 1];
            return suffix == 'm3u8';
          });
          if (el) {
            this.videoUrl = el.filePreviewUrl;
            setTimeout(() => {
              this.playVideo();
            }, 500)
          }
          typeof callback == 'function' && callback();
        }
      })
    },
    handleClose() {
      this.dialogVisible = false;
      this.isDestroy = true;
    },
    save() {
      if (this.radio && !this.currentId) {
        this.$msg({
          showClose: true,
          message: "请先选择进度",
          type: "warning",
        });
        return;
      }
      if (this.currentType == '仿真软件') {
        this.addSoftware();
        return;
      }
      this.addResource();
    },
    changeType(index) {
      if (index == this.currentType) return;
      this.currentType = index;
      let dialog1 = this.$refs.software_chunk;
      let dialog2 = this.$refs.chunk1;
      dialog1 && (dialog1.fileArr = []);
      dialog2 && (dialog2.fileArr = []);
      this.form.fileId = '';
      this.form.fileName = '';
      if (index == '题库' && this.activeName == 'local') {
        this.activeName = 'myself';
      }
      this.handleClick();
    },
  },
};
</script>

<style lang="less" scoped>
.res-img {
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: all 0.3s;
}

/deep/.el-dialog__title {
  font-size: 16px;
  font-weight: 700;
  color: #334681;
}

.software-item {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;

  &> :nth-child(2) {
    margin-left: 2rem;
  }
}

.input-box {
  display: flex;
  align-items: center;
  position: absolute;
  right: 2rem;
  top: 1rem;
  z-index: 99;

  &> :nth-child(1) {
    margin-right: 1rem;
    cursor: pointer;
  }
}

.top-box {
  display: flex;
  align-items: center;
  padding-bottom: 3rem;
}

.type-label {
  text-align: center;
  font-size: 14px;
  line-height: 2rem;
  width: 3rem;
  height: 2rem;
  margin-left: 1rem;
}

/deep/.el-dialog {
  border-radius: 1rem;
}

.video-p {
  position: relative;

  .stop {
    position: absolute;
    top: 24.5rem;
    left: -5px;
    cursor: pointer;
    height: 3rem;
  }

  .slider {
    position: absolute;
    top: 26.7rem;
    left: -5px;
    cursor: pointer;
  }
}

.content-box {
  height: 50rem;
  margin-top: 2rem;
  display: flex;

  .left-box {
    height: 100%;
    width: 54rem;
    border: 1px solid #e8ecef;
    padding: 2rem;
    overflow: auto;

    .video-box {
      width: 100%;
      height: 30rem;
    }

    &> :nth-child(2) {
      margin-top: 1rem;
      max-height: calc(100% - 33rem);
      overflow: auto;
    }
  }

  .right-box {
    margin-left: 2rem;
    flex: 1;
    border: 1px solid #e8ecef;
    position: relative;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;

  &> :nth-child(2) {
    margin-left: 4rem;
  }
}

/deep/#tab-myself {
  padding-left: 2rem !important;
}

/deep/.el-tabs__item {
  height: 6rem;
  line-height: 6rem;
}

/deep/.el-tabs__active-bar {
  height: 3px;
}

/deep/.el-tabs__content {
  height: calc(100% - 6rem);
}

/deep/.el-tabs {
  height: 100%;
}

/deep/.el-tab-pane {
  height: 100%;
}

/deep/.el-tabs__header {
  margin: 0 !important;
}

.left-box-container {
  width: 10rem;
  height: 100%;
  border-right: 1px solid #e8ecef;
  display: flex;
  flex-direction: column;
  align-items: center;

  &> :nth-child(n) {
    margin-top: 3rem;

    i {
      font-size: 2rem;
      cursor: pointer;
    }
  }
}

.right-box-container {
  flex: 1;
  overflow: auto;
  padding: 2rem;
}

.select-box {
  background-color: #cadff3;
  padding: 0 2rem 1rem 0;
  display: flex;
  border-radius: 4px;
  flex-wrap: wrap;

  .select-item {
    padding: 2px 4px;
    color: #387dff;
    background-color: rgba(56, 125, 255, 0.2);
    margin-left: 2rem;
    margin-top: 1rem;
  }

}

.box-content {
  height: 100%;
  display: flex;
  width: 100%;
}

.table-box {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 100%;

  &> :nth-child(n) {
    width: 19rem;
    margin-left: 2rem;
  }

  &> :nth-child(n+5) {
    margin-top: 2rem;
  }

  &> :nth-child(4n + 1) {
    margin-left: 0;
  }
}

.cover-box {
  width: 100%;
  aspect-ratio: var(--aspectRatio);
  background: rgba(56, 125, 255, 0.5);
  border-radius: 4px;
}

.select-item {
  display: flex;
  align-items: center;

  i {
    margin-left: 1.5rem;
    margin-top: 0.2rem;
  }
}

.active {
  color: var(--blue) !important;
}

.tip-box {
  display: flex;
  align-items: center;
  color: var(--blue);
  padding-left: 6rem;
  margin-top: 1rem;

  &> :nth-child(2) {
    margin-left: 0.5rem;
  }
}

.table-item {
  cursor: pointer;
}

.active-select {
  color: var(--blue) !important;
  font-weight: 700;
}

/deep/.el-upload {
  width: 100%;
  height: 99%;
}

/deep/.el-upload-dragger {
  height: 100%;
}

.active-time {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: var(--red);
  position: absolute;
  top: 27.4rem;
  left: -5px;
}

.radio-box {
  padding-bottom: 3rem;
  border-bottom: 1px solid #EAEBF0;
  display: flex;
  align-items: center;
  color: #8590B3;

  &> :nth-child(1) {
    margin-top: -4px;
  }
}

.t-cover-box {
  margin-bottom: 3rem;
  display: flex;
  align-items: center;

  &> :nth-child(1) {
    margin-right: 1rem;
  }
}

.upload-box-img {
  /deep/.el-upload {
    width: 5rem;
    height: 5rem;
    position: relative;
  }

  /deep/.el-icon-plus {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  /deep/.el-upload--picture-card {
    border: 1px solid #e8ecef;
    background: #ffffff;
  }
}

.mi-tip-box {
  width: 100%;
  text-align: center;
  margin-top: 20rem;
  font-weight: 700;
  font-size: 14px;
}

.page-box {
  text-align: center;
  width: 100%;
  padding: 2rem 0;
  position: absolute;
  bottom: 0;
  left: 0;
}

.num1 {
  width: 2rem;
  height: 2rem;
  color: #ffffff;
  display: flex;
  font-size: 12px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: absolute;
  top: -1.8rem;
  left: -1rem;
  background-color: red;
}

.num2 {
  position: absolute;
  top: 0;
  right: -4rem;
  color: #000000;
  font-size: 12px;
}

/deep/.table {
  height: 100%;
}

.operation-text {
  color: var(--blue);
  cursor: pointer;
}

.html-ev {
  display: flex;
  align-items: center;

  & :nth-child(n) {
    display: flex;
    align-items: center;
    font-size: 14px !important;
  }

  /deep/ img {
    max-width: 2rem !important;
    max-height: 2rem !important;
    width: auto;
    height: auto;
  }
}

.type-img-style {
  width: 2.2rem;
  height: auto;
  cursor: pointer;
}

.search-img {
  cursor: pointer;
  width: 16px;
  position: absolute;
  top: 50%;
  left: 0.5rem;
  transform: translateY(-50%);
}

/deep/.backimg {
  height: calc(100% - 7rem);
}
</style>
